<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Payroll List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Year </label>
          <select [(ngModel)]="Filter_year" (change)="ReadData_Salary()" class="custom-select">
            <option value="1403">Year 1403</option>
            <option value="1404">Year 1404</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Month </label>
          <select [(ngModel)]="Filter_month" (change)="ReadData_Salary()" class="custom-select">
            <option value="1">Farvardin</option>
            <option value="2">Ordibehesht</option>
            <option value="3">Khordad</option>
            <option value="4">Tir</option>
            <option value="5">Mordad</option>
            <option value="6">Shahrivar</option>
            <option value="7">Mehr</option>
            <option value="8">Aban</option>
            <option value="9">Azar</option>
            <option value="10">Dey</option>
            <option value="11">Bahman</option>
            <option value="12">Esfand</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Salary()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>

              <th>Full Name</th>
              <th>Fixed Salary</th>
              <th>Transportation Allowance</th>
              <th>Overtime Pay</th>
              <th>Mission Allowance</th>
              <th>Total Earnings</th>
              
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Salary
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Salary|filter:Filter_title:'fullname').length
                      }
            ">

              <tr>
                <td rowspan="3">{{DataList_Salary.indexOf(item)+1}}</td>
                
                <td rowspan="3">{{item.fullname}}</td>

                <td>{{item.salary|number}}</td>
                <td>{{item.ayabZohab|number}} </td>
                <td>{{item.ezakekar|number}} </td>
                <td>{{item.mission|number}} </td>

                <td rowspan="3">{{item.salary2|number}} </td>
                <td rowspan="3">
                  <button (click)="Set_Form_Salary_View_Add2(item.personId)" type="button"
                    class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Details
                  </button>
                </td>
              </tr>
              <tr>

                <th>Overtime Hours</th>
                <td>{{item.ezakekarCount}} </td>
                
                <th>Mission Count</th>
                <td>{{item.missionCount}} </td>
              </tr>

              <tr>
                <th>Employee Insurance Amount</th>
                <td>{{item.bimehKargar|number}} </td>

                <th>Tax Amount</th>
                <td>{{item.maliatPay|number}} </td>
              </tr>

            </ng-container>


          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<app-SalaryFish *ngIf="Selected_Salary_Record_Switcher=='Fish'" 
  (outter_Salary)="Set_List_Salary_View()"
  [innerYear]="Selected_Salary_Year" [innerMonth]="Selected_Salary_Month" [innerPersonId]="Selected_Salary_PersonId">

</app-SalaryFish>